module.exports = __webpack_public_path__ + "static/media/arrow-icon-full-bright-green-right.70b3338f.svg";